import TriggerConfigSerializer from 'eflex/serializers/trigger-config';

export default class WorkInstructionHardwareTriggerConfigSerializer extends TriggerConfigSerializer {
  constructor() {
    super(...arguments);
    this.attrs.animations = { embedded: 'always' };
  }
}
